// Runtime app settings: fetched from this app's CDN once, cached in memory, kept off the MF runtime path.

let cache = null;

/** Cached app settings, or {} before loadAppSettings() resolves. */
export function getAppSettings() {
  return cache || {};
}

/** Test/host seam: set the cache; pass null to force a refetch. */
export function setAppSettings(value) {
  cache = value;
}

/** Fetch + cache appsettings.json once; fails soft to {} with cache left null to retry. */
export async function loadAppSettings() {
  if (cache) return cache;

  // The remote's own origin, not the host's: appsettings.json sits at this app's deployment
  // root, one level above the chunk this code is bundled into (build.assetsDir = 'assets'; in
  // dev the module is served from /src/). That is the same relative hop Vite's own preload
  // helper uses to resolve assets under publicPath 'auto', and there is no webpack
  // public-path global to read instead.
  //
  // Deliberately NOT `new URL('.', import.meta.url)`. Vite treats a static first argument as
  // an asset reference and rewrites the whole expression at build time — here it replaced '.'
  // with a data: URL of src/index.js, producing ERR_INVALID_URL at runtime. Splitting the
  // string keeps it a plain runtime URL computation.
  const moduleUrl = import.meta.url;
  const baseUrl = new URL(`${moduleUrl.slice(0, moduleUrl.lastIndexOf('/') + 1)}../`).href;

  try {
    const response = await fetch(`${baseUrl}appsettings.json`, { cache: 'no-store' });
    if (!response.ok) throw new Error(`appsettings.json ${response.status}`);
    const data = await response.json();
    if (!data || typeof data !== 'object' || Array.isArray(data)) {
      throw new Error('appsettings.json is not a JSON object');
    }
    cache = data;
  } catch (error) {
    console.error('[customers-ui] failed to load appsettings.json', error);
    return {}; // leave cache null so the next mount retries
  }
  return cache;
}
